import { BaseStore } from "../extends/base-store";
import { ImasterContent } from "../interfaces/imaster-content";

export class DescuentoNominaStore extends BaseStore {
  objValores: Array<ImasterContent> = [];
  /**
   * @author Jose Wilson Mulato
   * @description Obtener valores por defecto de descuento nomina
   */
  protected async GetService() {
    this.objValores = [
    { descParametro: 'Una (1) cuota', consParametro: 'Una (1) cuota', valor: 'Una (1) cuota' }
     
    ,{ descParametro: 'Dos (2) cuotas', consParametro: 'Dos (2) cuotas', valor: 'Dos (2) cuotas' }, { descParametro: 'Tres (3) cuotas', consParametro: 'Tres (3) cuotas', valor: 'Tres (3) cuotas' }
  ];    
    this.objValores.forEach(x =>
      this.Data.push({ Label: x.descParametro, Value: x.consParametro })
    );
    return;
  }
}



// WEBPACK FOOTER //
// ./src/app/store/descnomina-store.ts